module.exports = __webpack_public_path__ + "cl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/cl.svg
// module id = 749
// module chunks = 0